const SearchClasses = Object.freeze({
	// Justify
	JustifyLeft: 'm-search-wrapper--left',
	JustifyRight: 'm-search-wrapper--right',
	// Sizes
	Large: 'm-search-wrapper--l',
});

export { SearchClasses };
